






import { computed, defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "OccBody",
  props: {
    size: {
      type: String,
      default: "medium",
      validator: (size: string) => {
        return ["", "small", "medium", "large"].includes(size);
      }
    },
    color: {
      type: String,
      default: "",
      validator: (color: string) => {
        return [
          "",
          "black",
          "white",
          "font",
          "font-deep",
          "font-light",
          "primary",
          "alert"
        ].includes(color);
      }
    },
    weight: {
      type: String,
      default: "",
      validator: (weight: string) => {
        return ["", "regular", "medium", "bold"].includes(weight);
      }
    },
    lineClamp: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const lineClampClassName = computed(() => {
      return props.lineClamp > 0
        ? {
            display: "-webkit-box",
            overflow: "hidden",
            "max-height": "initial",
            "-webkit-line-clamp": `${props.lineClamp}`,
            "-webkit-box-orient": "vertical"
          }
        : {};
    });
    const classes = computed(() => [
      props.size ? `occ-body__size--${props.size}` : "",
      props.color ? `occ-body__color--${props.color}` : "",
      props.weight ? `occ-body__weight--${props.weight}` : ""
    ]);
    return { lineClampClassName, classes };
  }
});
